import { BASE_URL } from "../BaseUrl.js"; 
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient")
  if (token) {
    config.headers.Authorization =  `Bearer ${token}`;
  } else {
    config.headers.Authorization =  null;
  }

  const codeEntite = localStorage.getItem("entiteSchoolCode")
  if (codeEntite) {
    config.headers['ref_entity'] = `client_${codeEntite}`;
  } else {
    config.headers['ref_entity'] =  null;
  }

  // const sousEntiteId = localStorage.getItem("sousEntiteId")
  // if (sousEntiteId) {
  //   config.headers['etablissementId'] = `${sousEntiteId}`;
  // } else {
  //   config.headers['etablissementId'] =  null;
  // }

  return config;
});

const customHeader = {
  etablissementId: localStorage.getItem("sousEntiteId")
    ? localStorage.getItem("sousEntiteId")
    : null,
};

export const getListeUtilisateur = async (page, size, param) => {
  return await axios.get(
    BASE_URL(`adminetablissement/rechercherutilisateurs?page=${page}&size=${size}&param=${param}`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const ajoutUtilisateur = async (values) => {
  return await axios.post(
    BASE_URL("adminetablissement/enregistrerUtilisateur"),
    values,
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const modificationUtilisateur = async (values) => {
  return await axios.post(
    BASE_URL("adminetablissement/modifierUtilisateur"),
    values,
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const rechercherUtilisateurParParam = async (page, size, param = "", annee = "", niveau = "") => {
  return await axios.get(
    BASE_URL(`etablissement/listeeleves?anneeId=${annee}&niveauId=${niveau}&page=${page}&param=${param}&size=${size}`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const supprimerUtilisateurParId = async (userId) => {
  return await axios.post(
    BASE_URL(`admin/zzdz/${userId}`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const changerEtatUtilisateurParId = async (userId) => {
  return await axios.post(
    BASE_URL(`adminetablissement/changeretatcompteutilisateur/${userId}`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const modifierIdentifiantAdmin = async (values) => {
  return await axios.post(
    BASE_URL("reinitialiserpassword"),
    values,
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};